import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// Relocates header content into a SubHeader (L2) zone when that zone exists in the DOM,
// otherwise renders inline (so apps/pages without the L2 chrome — feel, deal admin — keep
// their current layout). The WHOLE form is moved as one unit, so the form's DOM-based
// value collection (LegacyForm reads form.querySelectorAll) keeps working.
const findNode = id => typeof document !== 'undefined' ? document.getElementById(id) : null;

// True when the L2 SubHeader chrome is mounted (deal provider section). Lets ContainerHeader
// render its L2 layout there and keep the original inline layout everywhere else.
export const useL2Present = (targetId = 'admin-header-start') => {
  const [present, setPresent] = useState(() => !!findNode(targetId));
  useEffect(() => {
    if (findNode(targetId)) {
      setPresent(true);
      return undefined;
    }
    const observer = new MutationObserver(() => {
      if (findNode(targetId)) {
        setPresent(true);
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, [targetId]);
  return present;
};
const HeaderZone = ({
  targetId,
  children
}) => {
  const [node, setNode] = useState(() => findNode(targetId));
  useEffect(() => {
    if (findNode(targetId)) {
      setNode(findNode(targetId));
      return undefined;
    }
    const observer = new MutationObserver(() => {
      const found = findNode(targetId);
      if (found) {
        setNode(found);
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, [targetId]);
  if (!children) {
    return null;
  }
  // Inline fallback (no L2 chrome): render children as before.
  if (!node) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/createPortal(children, node);
};
export default HeaderZone;